import types from '../types'
import {onSignInSuccess} from './onSignInSuccess'

export const signIn = ({orgId, authKey}) => async (dispatch) => {
  if (!orgId || !authKey) {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        userMessage: 'Please include Organization ID and Auth Key',
        notificationType: 3,
        notificationIcon: 'warning',
      },
    })
    return
  }
  dispatch({
    type: types.STORE_PAYLOAD,
    payload: {isLoading: true},
  })
  try {
    const res = await fetch(`${process.env.REACT_APP_METRICS_URL}api/auth`, {
      headers: {orgId, authKey},
    })
    const body = await res.json()
    if (res.ok && body?.authenticated) {
      dispatch(onSignInSuccess(orgId, authKey))
    } else {
      dispatch({
        type: types.STORE_PAYLOAD,
        payload: {
          isLoading: false,
          userMessage: 'Error: Invalid Organization ID or Auth Key.',
          notificationType: 3,
          notificationIcon: 'warning',
        },
      })
    }
  } catch (error) {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        isLoading: false,
        userMessage: 'Error: Failed to reach authentication service.',
        notificationType: 3,
        notificationIcon: 'warning',
      },
    })
  }
}
